import {
  $delayToast,
  genToaster,
} from '@qs-plus/components/toaster'
import type { App } from 'vue'

const $pxSuccess = genToaster('success', 'qs-toaster px-success-toaster')
const $success = genToaster('success', 'ai-toaster', { offset: 85 })
const $info = genToaster('info', 'ai-toaster', { offset: 85 })
const $error = genToaster('error', 'ai-toaster', { offset: 85 })
const $warning = genToaster('warning', 'ai-toaster', { offset: 85 })

export { $info, $error, $success, $warning, $pxSuccess, $delayToast }

export default {
  install: (app: App) => {
    app.config.globalProperties['$success'] = $success
    app.config.globalProperties['$error'] = $error
    app.config.globalProperties['$info'] = $info
    app.config.globalProperties['$warning'] = $warning
    app.config.globalProperties['$delayToast'] = $delayToast
  },
}
